import React, { FC } from 'react';
import { Resizable } from 're-resizable';
import { enableCheck } from './Helpers';
import styles from './Annotation.module.scss';
import classNames from 'classnames';

type Props = {
  widthProp: number;
  enable: boolean;
  setHideStichedView?: (hide: boolean) => void;
  setHideTree?: (hide: boolean) => void;
  setTreeWidth?: (treeWidth: number) => void;
  setWidth: (width: number) => void;
  maxWidth: number;
  minWidth: number;
  hideStichedView?: boolean;
  hideTree?: boolean;
  fullScreenMode: boolean;
  children: any;
  left: boolean;
};

export const Resizer: FC<Props> = ({
  widthProp,
  enable,
  setHideStichedView,
  setWidth,
  maxWidth,
  minWidth,
  setHideTree,
  setTreeWidth,
  hideStichedView,
  fullScreenMode,
  children,
  left,
  hideTree
}) => {
  return (
    <Resizable
      className={classNames(left ? styles.left : styles.sidePanel, styles.resizer, {
        [styles.hideLeft]: hideStichedView,
        [styles.minimize]: fullScreenMode || hideTree || fullScreenMode || hideStichedView,
        [styles.sidePanelStichedViewClosed]: hideStichedView
      })}
      defaultSize={{
        width: `${widthProp}%`,
        height: 'auto'
      }}
      minWidth={`${hideTree ? 0 : ''}%`}
      maxWidth={`${maxWidth}%`}
      enable={enableCheck(enable)}
      as='object'
      scale={1}
      onResizeStop={(e, direction, ref, d) => {
        if (parseInt(ref.style.width) <= minWidth) {
          setHideTree && setHideTree(true);
          setHideStichedView && setHideStichedView(true);
        }
        setWidth(d.width);
        setTreeWidth && setTreeWidth(widthProp);
      }}
    >
      {children}
    </Resizable>
  );
};
